module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in-right-big/wow-fade-in-right-big.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in-right-big/wow-fade-in-right-big.component.scss
// module chunks = main